import { BaseNode } from "./baseNode";

export const DelayNode = ({ id }) => {
  return (
    <BaseNode
      id={id}
      title="Delay"
      leftHandles={[
        { id: `${id}-input`, top: '50%', label: 'Input' }
      ]}
      rightHandles={[
        { id: `${id}-output`, top: '50%', label: 'Output' }
      ]}
    >
      <div>Wait for X seconds</div>
    </BaseNode>
  );
};
